import { z } from 'zod';

import { TeamMemberRole } from '__generated__/GQL';

export const EDITABLE_ROLES = [
  TeamMemberRole.Admin,
  TeamMemberRole.Employee,
  TeamMemberRole.Accountant,
] as const;

export type EditableRole = (typeof EDITABLE_ROLES)[number];

export const memberInformationRoleFormSchema = z.object({
  role: z.enum(EDITABLE_ROLES),
});

export type MemberInformationRoleFormSchema = z.infer<
  typeof memberInformationRoleFormSchema
>;
